import React from 'react';
import PropTypes from 'prop-types';

const Switch = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.73203 2L3.2017 1.46967L3.73203 0.93934L4.26236 1.46967L3.73203 2ZM4.48203 11C4.48203 11.4142 4.14625 11.75 3.73203 11.75C3.31782 11.75 2.98203 11.4142 2.98203 11L4.48203 11ZM0.801701 3.86967L3.2017 1.46967L4.26236 2.53033L1.86236 4.93033L0.801701 3.86967ZM4.26236 1.46967L6.66236 3.86967L5.6017 4.93033L3.2017 2.53033L4.26236 1.46967ZM4.48203 2L4.48203 11L2.98203 11L2.98203 2L4.48203 2Z"
      fill={color}
    />
    <path
      d="M8.53281 14L8.00248 14.5303L8.53281 15.0607L9.06314 14.5303L8.53281 14ZM9.28281 5C9.28281 4.58579 8.94703 4.25 8.53281 4.25C8.1186 4.25 7.78281 4.58579 7.78281 5L9.28281 5ZM5.60248 12.1303L8.00248 14.5303L9.06314 13.4697L6.66314 11.0697L5.60248 12.1303ZM9.06314 14.5303L11.4631 12.1303L10.4025 11.0697L8.00248 13.4697L9.06314 14.5303ZM9.28281 14L9.28281 5L7.78281 5L7.78281 14L9.28281 14Z"
      fill={color}
    />
  </svg>
);

Switch.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Switch;
